

import __layout_0 from '/D:/Projects/deploying-vue-bo/boe-int-fe/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/D:/Projects/deploying-vue-bo/boe-int-fe/src/layouts/blank.vue'),
'default': __layout_0,
'new-home': () => import('/D:/Projects/deploying-vue-bo/boe-int-fe/src/layouts/new-home.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/D:/Projects/deploying-vue-bo/boe-int-fe/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/D:/Projects/deploying-vue-bo/boe-int-fe/src/layouts/components/Footer.vue'),
'components/FooterBlank': () => import('/D:/Projects/deploying-vue-bo/boe-int-fe/src/layouts/components/FooterBlank.vue'),
'components/NavBarNotifications': () => import('/D:/Projects/deploying-vue-bo/boe-int-fe/src/layouts/components/NavBarNotifications.vue'),
'components/NavbarShortcuts': () => import('/D:/Projects/deploying-vue-bo/boe-int-fe/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/D:/Projects/deploying-vue-bo/boe-int-fe/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/NavSearchBar': () => import('/D:/Projects/deploying-vue-bo/boe-int-fe/src/layouts/components/NavSearchBar.vue'),
'components/UserIconProfile': () => import('/D:/Projects/deploying-vue-bo/boe-int-fe/src/layouts/components/UserIconProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
